import React from 'react';
import { useTranslation } from 'react-i18next';
import { HomeTaskAttachments } from '@/components/HomeTaskModal/HomeTaskAttachments';
import type { Attachment } from '@/types/attachment';
import type { HomeTaskMessage } from '@/types/diary';
import { formatDayMonthTime } from '@/utils/date';
import { sanitizeRichTextHtml } from '@/utils/html';
import { getFullName } from '@/utils/text';

interface Props {
  message: HomeTaskMessage;
  isOwn: boolean;
  onPreview: (attachment: Attachment) => void;
}

export const ChatMessageCard: React.FC<Props> = ({
  message,
  isOwn,
  onPreview,
}) => {
  const { t } = useTranslation();

  const { value, time, author } = message;
  const authorName = isOwn
    ? t('diary.homeTask.me')
    : `${getFullName(author)} (${author.personType})`;

  return (
    <div
      className={`flex px-4 ${isOwn ? 'md:pr-5 md:pl-14' : 'md:pr-14 md:pl-5'}`}
    >
      <div
        className={`flex min-w-0 flex-1 flex-col gap-4 rounded-xl p-4 ${isOwn ? 'items-end bg-on-primary-surface text-right' : 'items-start bg-info-surface'}`}
      >
        <div className="flex w-full min-w-0 flex-col gap-0.5">
          <p className="text-caption-12 text-subtle-foreground">
            {`${authorName}, ${formatDayMonthTime(time)}`}
          </p>
          <div
            className="rich-text text-body-14 text-foreground"
            dangerouslySetInnerHTML={{
              __html: sanitizeRichTextHtml(value.text),
            }}
          />
        </div>

        <HomeTaskAttachments
          attachments={value.attachments}
          isAlignedRight={isOwn}
          onPreview={onPreview}
        />
      </div>
    </div>
  );
};
